import axios from 'axios';

import { PERFIL, CONFIGURACION } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

/* Métodos */
export const buscarMetodosConfiguracion = () => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/listar`);
        await dispatch({ type: CONFIGURACION.METODOS.BUSCAR, payload: res.data.metodos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearMetodo = (metodoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(metodoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/crear`, body, config);
        await dispatch({ type: CONFIGURACION.METODOS.AGREGAR, payload: res.data.metodo });
        await dispatch(setAlert(res.data.msg || 'Método creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarMetodo = (metodoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(metodoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/editar`, body, config);
        await dispatch({ type: CONFIGURACION.METODOS.EDITAR, payload: res.data.metodo });
        await dispatch(setAlert(res.data.msg || 'Método editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarMetodo = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/eliminar`, body, config);
        await dispatch({ type: CONFIGURACION.METODOS.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Método eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerMetodo = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/metodos/detalles`, body, config);
        await dispatch({ type: CONFIGURACION.METODOS.DETALLES, payload: res.data.metodo });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarMetodo = () => dispatch => {
    dispatch({ type: CONFIGURACION.METODOS.LIMPIAR });
};

/* Productos */
export const buscarProductosConfiguracion = () => async dispatch => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/configuracion/productos/listar`);
        await dispatch({ type: CONFIGURACION.PRODUCTOS.BUSCAR, payload: res.data.productos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearProductoConfiguracion = (productoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(productoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/productos/crear`, body, config);
        await dispatch({ type: CONFIGURACION.PRODUCTOS.AGREGAR, payload: res.data.producto });
        await dispatch(setAlert(res.data.msg || 'Producto creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarProductoConfiguracion = (productoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(productoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/productos/editar`, body, config);
        await dispatch({ type: CONFIGURACION.PRODUCTOS.EDITAR, payload: res.data.producto });
        await dispatch(setAlert(res.data.msg || 'Producto editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarProductoConfiguracion = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/productos/eliminar`, body, config);
        await dispatch({ type: CONFIGURACION.PRODUCTOS.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Producto eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerProductoConfiguracion = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/productos/detalles`, body, config);
        await dispatch({ type: CONFIGURACION.PRODUCTOS.DETALLES, payload: res.data.producto });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarProductoConfiguracion = () => dispatch => {
    dispatch({ type: CONFIGURACION.PRODUCTOS.LIMPIAR });
};

/* Perfil */
export const guardarPerfil = (perfil) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/configuracion/editar_perfil`, perfil, config);

        await dispatch({
            type: PERFIL.EDITAR,
            payload: res.data.perfil
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}
